module.exports = __webpack_public_path__ + "media/stylesheets/images/media/user_way_hero_mobile-62017e1d4ab938ac8ce02c5685365bc9.png";